import State from '@/onsite/models/state.model';

const getters = {
  getTranslations(state: State) {
    return state.translations
  },
  getQueryString(state: State) {
    return state.queryString
  },
  getProductResults(state: State) {
    return state.productGroup.results
  },
  getProductTotalResults(state: State) {
    return state.productGroup.totalResults
  },
  getTotalResults(state: State) {
    return state.totalResults
  },
  getGroups(state: State) {
    return state.groups
  },
  getAllTabStatus(state: State) {
    return state.allTabSelected
  }
};

export default getters;
